import { render, staticRenderFns } from "./_videoList.vue?vue&type=template&id=7d05009a&scoped=true&lang=pug&"
var script = {}
import style0 from "./_videoList.vue?vue&type=style&index=0&id=7d05009a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d05009a",
  null
  
)

export default component.exports